import React, { Component } from "react";
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonLabel,
  IonModal,
  IonButtons,
  IonButton,
  IonBackButton,
  IonImg,
} from "@ionic/react";
import { isPlatform } from "@ionic/core";

import { TransformWrapper, TransformComponent, ReactZoomPanPinchRef } from "react-zoom-pan-pinch";

// Images
import iconBookmarkActive from "../assets/Button_Bookmark_2Active@3x.png";
import iconBookmarkInactive from "../assets/Button_Bookmark_1Inactive@3x.png";
import buttonClose from "../assets/Button_Close@3x.png";

// CSS
import "../Shared.css";
import "../../App.css";
import "./ImageViewerModal.css";
import jrcalcLogo from "../assets/logo_jrcalc@2x.png";
import aaceLogo from "../assets/logo_AACE@2x.png";
import { IScreenProps, IUser } from "../Interfaces";
import DataController from "../controllers/DataController";

type Props = {
  isOpen: boolean;
  toggleImageModal: (shouldShow: boolean) => void;
  bookmarkButtonPressed: () => void;
  isBookmarked: boolean;
  imageSrc: string;
  isReferenceCard: boolean;
  referenceCardImageTags?: string[];
  tab: string;
};
type State = {
  minImageScale: number;
  touchStartY: number;
  touchStartTime: number;
};

class ImageViewerModal extends Component<Props, State> {
  private imageModalZoom: React.RefObject<ReactZoomPanPinchRef>;

  constructor(props: Props) {
    super(props);

    this.imageModalZoom = React.createRef();

    this.state = {
      minImageScale: 1,
      touchStartY: 0,
      touchStartTime: 0,
    };
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
    if (prevProps.isOpen === false && this.props.isOpen === true) {
      this.updateZoom();
    }
  }

  updateZoom() {
    setTimeout(() => {
      // zoom image to correct scale
      if (this.imageModalZoom.current) {
        let imageModalImage = document.getElementById("imageModalImage");
        let imageModalWrapper = document.getElementById("imageModalWrapperClass");
        if (imageModalImage != null && imageModalWrapper != null) {
          let scale = Math.min(
            imageModalWrapper.clientWidth / imageModalImage.clientWidth,
            imageModalWrapper.clientHeight / imageModalImage.clientHeight
          );
          if (scale < 1) {
            this.imageModalZoom.current.centerView(scale, 0);
            this.setState({ minImageScale: scale });
          } else {
            this.imageModalZoom.current.centerView(1, 0);
            this.setState({ minImageScale: 1 });
          }
        }
      }
    }, 100);
  }

  onImagePanningStart(ref: ReactZoomPanPinchRef, event: any) {
    this.setState({ touchStartY: ref.state.positionY, touchStartTime: new Date().getTime() });
  }

  onImagePanningEnd(ref: ReactZoomPanPinchRef, event: any) {
    const touchEndY = ref.state.positionY;
    const touchEndTime = new Date().getTime();

    const deltaY = touchEndY - this.state.touchStartY;
    const deltaTime = touchEndTime - this.state.touchStartTime;

    // Check for fast vertical swipe (down or up)
    if (this.props.isReferenceCard !== true && touchEndY >= 100 && Math.abs(deltaY) >= 100 && deltaTime < 200) {
      this.props.toggleImageModal(false);
    }
  }

  // onImagePanning(ref: ReactZoomPanPinchRef, event: any) {
  //   console.log(ref.instance.lastDistance);
  //   if (this.props.isReferenceCard !== true && ref.state.positionY >= 100) {
  //     this.props.toggleImageModal(false);
  //   }
  // }

  render() {
    let imageThumbnailsLayout = [];

    if (this.props.referenceCardImageTags) {
      for (
        let referenceCardImageTagIndex = 0;
        referenceCardImageTagIndex < this.props.referenceCardImageTags.length;
        referenceCardImageTagIndex++
      ) {
        let referenceCardImageTag = this.props.referenceCardImageTags[referenceCardImageTagIndex];
        imageThumbnailsLayout.push(<div dangerouslySetInnerHTML={{ __html: referenceCardImageTag }} />);
      }
    }

    return (
      <IonModal
        id="imageModal"
        mode="ios"
        animated={!this.props.isReferenceCard}
        isOpen={this.props.isOpen}
        onDidDismiss={() => this.props.toggleImageModal(false)}
      >
        <IonHeader>
          {isPlatform(window, "mobile") && !isPlatform(window, "tablet") ? (
            <IonToolbar mode="ios" color="#008477" className="imageModalHeaderPhone navBar">
              <div className="modalTitleSliver" />
              <div className="imageModalTitlePhone" />
              {this.props.isReferenceCard ? (
                <>
                  <IonButtons slot="start" className="headerButtonText" color="#FFFFFF">
                    <IonBackButton defaultHref={`/${this.props.tab}`} class="headerButtonText" />
                  </IonButtons>

                  <IonButtons slot="end" className="phoneModalClose">
                    <IonButton className="headerButtons" onClick={() => this.props.bookmarkButtonPressed()}>
                      <IonImg src={this.props.isBookmarked ? iconBookmarkActive : iconBookmarkInactive} />
                    </IonButton>
                  </IonButtons>
                </>
              ) : (
                <IonButtons slot="end" className="phoneModalClose">
                  <IonButton className="headerButtons" onClick={() => this.props.toggleImageModal(false)}>
                    <img className="icon-44" src={buttonClose} />
                  </IonButton>
                </IonButtons>
              )}
            </IonToolbar>
          ) : (
            <IonToolbar className="imageModalHeader navBar" color="#008477" mode="ios">
              {this.props.isReferenceCard ? (
                <>
                  <IonButtons slot="start" className="headerButtonText" color="#FFFFFF">
                    <IonBackButton defaultHref={`/${this.props.tab}`} class="headerButtonText" />
                  </IonButtons>

                  <IonButtons slot="end" className="phoneModalClose">
                    <IonButton className="headerButtons" onClick={() => this.props.bookmarkButtonPressed()}>
                      <IonImg src={this.props.isBookmarked ? iconBookmarkActive : iconBookmarkInactive} />
                    </IonButton>
                  </IonButtons>
                </>
              ) : (
                <IonButtons slot="end">
                  <IonButton className="headerButtons" onClick={() => this.props.toggleImageModal(false)}>
                    <img className="icon-44" src={buttonClose} />
                  </IonButton>
                </IonButtons>
              )}
            </IonToolbar>
          )}
        </IonHeader>
        <IonContent id="imageModalContent">
          <div className="imageModalOuterDiv">
            <div id="imageModalWrapperClass">
              <TransformWrapper
                ref={this.imageModalZoom}
                centerZoomedOut={true}
                centerOnInit={true}
                minScale={this.state.minImageScale}
                // onPanning={this.onImagePanning.bind(this)}
                onPanningStart={this.onImagePanningStart.bind(this)}
                onPanningStop={this.onImagePanningEnd.bind(this)}
              >
                <TransformComponent wrapperClass="imageModalWrapper" contentClass="imageModalContent">
                  <div id="imageModalImage" dangerouslySetInnerHTML={{ __html: this.props.imageSrc }} />
                </TransformComponent>
              </TransformWrapper>
            </div>
            {imageThumbnailsLayout.length > 1 ? (
              <div className="imageModalThumbnails">{imageThumbnailsLayout}</div>
            ) : null}
            {this.props.isReferenceCard ? (
              <div className="referenceCardViewGuideline" onClick={() => this.props.toggleImageModal(false)}>
                View Guideline
              </div>
            ) : null}
          </div>
        </IonContent>
        <div className="appColorOverlay" />
      </IonModal>
    );
  }
}

export default ImageViewerModal;
